import gestionXml from '../../Actions/gestionXml';

const {types} = gestionXml;

const getEfosOriginalState = () => {
    return {
        form: {
            DocumentType: 'Emision',
            StartDate: '',
            EndDate: '',
            TaxId: '',
            RequestType: 'Metadata'
        },
        data: [],
        paginatation: {
            page: 1,
            pageCount: 1,
            perPage: 10,
            totalCount: 10
        },
        lastRequest: null,
    };
}

export const DefaultfilteredDownloadsPagination = () => {
    return {
        page: 1,
        pageCount: 1,
        perPage: 10,
        totalCount: 10,
        taxId: '',
        documents: 'Todos',
        type: 0,
        status: -1,
        startDate: '',
        endDate: '',
        taxIdIssuer: ''
    };
}

const initialState = {
    downloadXmls: {
        type: 'WebService',
        startDate: '',
        endDate: '',
        documents: 'Emision',
        CFDIStatus: 'Todos',
        createPDF: false,
        requiresNomina: false,
        taxId: '',
        generatePDF: false,
        googleDrive: false,
        includeCancellationDate: false,
        rfcsToFilter: [],
        generateReport: true,
        driveMessageVisible: true,
        rfcTPAccount: "",
        cfdiType: null,
        cfdiComplement: null
    },
    notificationSent: false,
    downloadsPagination: {
        page: 1,
        pageCount: 1,
        perPage: 10,
        totalCount: 10
    },
    filteredDownloadsPagination: {
        ...DefaultfilteredDownloadsPagination()
    },
    downloadsRequested: [],
    filteredDownloadsRequested: [],
    taxpayerVolume: [],
    efos: getEfosOriginalState(),
};

const gestionXmlReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.SET_DATA_DOWNLOAD_FILES:
            return {
                ...state,
                downloadXmls: {
                    ...state.downloadXmls,
                    ...action.data
                }
            }
        case types.SET_DOWNLOADED_FILES:
            return {
                ...state,
                downloadsRequested: action.data
            }
        case types.SET_FILTERED_DOWNLOADED_FILES:
            return {
                ...state,
                filteredDownloadsRequested: action.data
            }
        case types.UPDATE_DOWNLOADS_PAGINATION:
            return {
                ...state,
                downloadsPagination: action.data
            }
        case types.UPDATE_FILTERED_DOWNLOADS_PAGINATION:
            return {
                ...state,
                filteredDownloadsPagination: action.data
            }
        case types.SET_FILTERED_DATA:
            return {
                ...state,
                filteredDownloadsPagination: {
                    ...state.filteredDownloadsPagination,
                    ...action.data
                }
            }
        case types.NOTIFICATION_SENT: {
            return {
                ...state,
                notificationSent: action.status
            }
        }
        case types.SET_TAXPAYER_VOLUME_DATA: {
            return {
                ...state,
                taxpayerVolume: action.data
            }
        }
        case types.SET_EFOS_REQUEST_DATA: {
            return {
                ...state,
                efos: {
                    ...state.efos,
                    data: action.data
                }
            }
        }
        case types.UPDATE_EFOS_DATA_FORM: {
            return {
                ...state,
                efos: {
                    ...state.efos,
                    form: {
                        ...state.efos.form,
                        ...action.data
                    }
                }
            }
        }
        case types.RESTART_EFOS_STATE:
            return {
                ...state,
                efos: getEfosOriginalState(),
            }
        case types.SET_LAST_EFOS_REQUEST:
            return {
                ...state,
                efos: {
                    ...state.efos,
                    lastRequest: action.data,
                }
            };
        default:
            return state;
    }
}

export default gestionXmlReducer;